module.exports = __webpack_public_path__ + "static/media/M.0269c3fe.jpg";